<div style="margin-top: 100px; padding-left: 15px; padding-right: 15px;" fxLayoutGap="15px">

    <!--#region Start Left Side-->
    <div fxLayout="column" [style.height.px]="columnMaxHeight" fxFlex="25" class="left-side">
        <div fxLayout="row" fxFlex="grow">
            <div fxLayout="column" fxFlex="grow">

                <span style="font-size: 18px;">Δημιουργία προσαρμοσμένης δήλωσης</span>

                <table style="width: 100%;">
                    <tr>
                        <td style="width: 20%;">Τίτλος:</td>
                        <td style="width: 80%;">
                            <mat-form-field style="width: 100%;">
                                <label>
                                    <input matInput [(ngModel)]="formTitle" placeholder="Τίτλος δήλωσης"/>
                                </label>
                            </mat-form-field>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 20%;">Περιγραφή:</td>
                        <td style="width: 80%;">
                            <mat-form-field style="width: 100%;">
                                <label>
                                    <input matInput [(ngModel)]="formDescription" placeholder="Περιγραφή δήλωσης"/>
                                </label>
                            </mat-form-field>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 20%;">Τύπος δήλωσης:</td>
                        <td style="width: 80%;">
                            <mat-form-field style="width: 100%;">
                                <mat-select [(ngModel)]="formType">
                                   <mat-option *ngFor="let type of formTypes" [value]="type">{{type.label}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                    </tr>
                </table>
                <table>
                  <tr>
                    <td>
                      <label>Μήνυμα που θα εμφανίζεται μετά την επιτυχημένη υποβολή μιας δήλωσης :</label>
                    </td>
                  </tr>
                  <tr>
                    <td style="padding-top: 8px;">
                      <mat-form-field style="width: 99%;">
                        <textarea rows="1" cdkTextareaAutosize style="marign-right: 10px;" maxlength="500" matInput [(ngModel)]="formSubmitMessage" placeholder="Γράψτε το μήνυμα που θέλετε να εμφανίζεται"></textarea>
                      </mat-form-field>
                    </td>
                  </tr>
                </table>

                <div fxLayout="row" fxFlex="grow" fxLayoutGap="10px">
                    <div fxFlex="grow">
                        <button mat-mini-fab style="background-color: var(--secondaryLightGra)" (click)="openSettings()"
                                matTooltip="Ιδιότητες">
                            <mat-icon>settings</mat-icon>
                        </button>
                    </div>
                    <button mat-mini-fab style="background-color: var(--secondaryCyan)" (click)="setSections()"
                            matTooltip="Προσθήκη νέου τμήματος">
                        <mat-icon>add</mat-icon>
                    </button>
                    <button mat-mini-fab style="background-color: var(--primaryOrange)" color="primary"
                            (click)="tempSave()"
                            matTooltip="Προσωρινή αποθήκευση">
                        <mat-icon>save_alt</mat-icon>
                    </button>
                    <button *ngIf="!mode" [disabled]="isFormInValid()" mat-mini-fab
                            style="background-color: var(--secondaryBlue)" color="primary"
                            (click)="submitForm()" matTooltip="Αποθήκευση">
                        <mat-icon>save</mat-icon>
                    </button>
                    <button *ngIf="mode" [disabled]="isFormInValid()" mat-mini-fab
                            style="background-color: var(--secondaryBlue)" color="primary"
                            (click)="updateForm()" matTooltip="Ενημέρωση">
                        <mat-icon>update</mat-icon>
                    </button>
                </div>
            </div>
        </div>

        <div fxLayout="row" fxFlex>
            <app-options [sections]="sections" (expendedSection)="handledExpandedSection($event)"></app-options>
        </div>
    </div>
    <!--#endregion End Left Side-->

    <!--#region Start Right Side-->
    <div fxLayout="column" [style.height.px]="columnMaxHeight" fxFlex="75" class="right-side">
        <div fxLayout="row">
            <div style="padding:15px;">
                <app-display [sections]="sections" [expandedId]="expanded"></app-display>
            </div>
        </div>
    </div>
    <!--#endregion  End Right Side  -->

</div>


